import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { StorageManager } from "@/features/admin/components/storage-manager";
import { PageContainer } from "@fleet/ui";

function AdminStoragePage() {
  return (
    <PageContainer maxWidth="5xl">
      <StorageManager />
    </PageContainer>
  );
}

export interface AdminStorageSearch {
  /** Deep-link: object filter (all/orphaned/linked). */
  filter?: string;
}

export const adminStorageRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/storage",
  validateSearch: (search: Record<string, unknown>): AdminStorageSearch => ({
    filter: search.filter === "orphaned" || search.filter === "linked" ? search.filter : undefined,
  }),
  component: AdminStoragePage,
});
